import React from "react";
import PageBanner from "../../components/TermsPageComponents/PageBanner";
import { pgImg6 } from "../../components";

function PenetrationTestingTraining() {
  return (
    <>
      <section id="securityServicesPage" className="securityServicesPage">
        <div className="pagesBanner">
          <PageBanner PageTitle="Penetration Testing Training" />

          <div className="shapeSvg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
              <g id="Layer_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer" />
                <path
                  className="fil0"
                  d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
                />
              </g>
            </svg>
          </div>
        </div>
      </section>
      <section
        id="securityServicesContentWrap"
        className="securityServicesContentWrap"
      >
        <div className="container">
          <div className="col-md-12 col-12">
            <div className="contentWrap">
              <p>
                In the realm of security, penetration testing can be described
                in various ways. However, the most effective approach often
                involves the expertise of skilled hackers or a dedicated team.
                Version Next Technologies's Advanced Penetration Test training
                program is designed to provide hands-on experience rather than
                theoretical knowledge. You put what you learn into practice in
                real-world scenarios, which sets Version Next Technologies apart
                as the premier institute for Advanced Penetration Training in
                Mumbai.
              </p>
              <p className="mb-0">
                Our primary focus is to empower individuals to conduct
                vulnerability assessments and penetration tests, enabling them
                to thwart malicious attacks by hackers. Given the increasing
                number of security concerns and vulnerabilities faced by
                businesses, this skill has gained significant importance. All
                you need is the right VAPT (Vulnerability Assessment and
                Penetration Testing) training to kickstart your journey. If
                you're seeking VAPT training in Mumbai, Version Next
                Technologies stands as the unrivaled destination for the most
                advanced security and penetration test training.
              </p>
              <div className="row">
                <div className="col-md-5 mx-auto my-0">
                  <div className="pageImgWrap">
                    <img src={pgImg6} alt="Penetration Testing Training" />
                  </div>
                </div>
              </div>
              <p>
                The true measure of a system's security can only be assessed
                when real-world hackers attempt to breach it. This is precisely
                what we instruct our students to do, with ample practice that
                hones their skills. We stay abreast of the latest threats and
                vulnerabilities, ensuring our students are equipped to address
                them professionally.
              </p>
              <p>
                Our faculty comprises top-tier security analysts and ethical
                hackers who possess a deep understanding of penetration testing.
                Learning from them provides a significant boost to your IT
                career, transforming you into an expert in the field. As the
                leading VAPT training institute in Mumbai, we guarantee
                comprehensive knowledge and skill development that paves the way
                for a prosperous career.
              </p>
            </div>
            <div className="contentWrap">
              <div className="sedtionTitle">
                <h4>Course Outline</h4>
              </div>
              <div className="table-responsive courseTable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1. Introduction to Penetration Testing</td>
                    </tr>
                    <tr>
                      <td>2. Network Basics</td>
                    </tr>
                    <tr>
                      <td>3. Linux Basics</td>
                    </tr>
                    <tr>
                      <td>4. Information Gathering Techniques</td>
                    </tr>
                    <tr>
                      <td>
                        5. Target Enumeration and Port Scanning Techniques
                      </td>
                    </tr>
                    <tr>
                      <td>6. Vulnerability Assessment</td>
                    </tr>
                    <tr>
                      <td>7. Network Sniffing</td>
                    </tr>
                    <tr>
                      <td>8. Remote Exploitation</td>
                    </tr>
                    <tr>
                      <td>9. Client Side Exploitation</td>
                    </tr>
                    <tr>
                      <td>10. Post-Exploitation</td>
                    </tr>
                    <tr>
                      <td>11. Windows Exploit Development Basics</td>
                    </tr>
                    <tr>
                      <td>12. Wireless Testing</td>
                    </tr>
                    <tr>
                      <td>13. Web Applications Testing</td>
                    </tr>
                  </tbody>
                </table>
                <b className="boldTxt">
                  Each of the below module contains sub-topics, for complete
                  details contact us.
                </b>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PenetrationTestingTraining;
